import {
  aCustomMatchListColumn,
  mockCustomMatchListColumnsOperationQuery,
} from '__generated__';

export const CUSTOM_MATCH_LIST_COLUMN_DATA = {
  fields: ['action', 'application'],
  name: `Test Custom Column ${Date.now()}`,
  updatedName: `Test Custom Column Updated ${Date.now()}`,
  updatedFields: ['action', 'baseImage'],
};

export const customMatchListColumnQuery =
  mockCustomMatchListColumnsOperationQuery((_req, res, ctx) => {
    return res(
      ctx.delay(1500), // mock loading state
      ctx.data({
        __typename: 'Query',
        customMatchListColumns: [
          aCustomMatchListColumn({
            id: '1',
            fields: CUSTOM_MATCH_LIST_COLUMN_DATA.fields,
            name: CUSTOM_MATCH_LIST_COLUMN_DATA.name,
          }),
        ],
        customMatchListColumnLimit: 5,
      })
    );
  });

export const customMatchListColumnQuery_updated =
  mockCustomMatchListColumnsOperationQuery((_req, res, ctx) => {
    return res(
      ctx.delay(1500), // mock loading state
      ctx.data({
        __typename: 'Query',
        customMatchListColumns: [
          aCustomMatchListColumn({
            id: '1',
            fields: CUSTOM_MATCH_LIST_COLUMN_DATA.updatedFields,
            name: CUSTOM_MATCH_LIST_COLUMN_DATA.updatedName,
          }),
        ],
        customMatchListColumnLimit: 5,
      })
    );
  });

export const handlers = [
  mockCustomMatchListColumnsOperationQuery((_req, res, ctx) => {
    return res(
      ctx.delay(1500), // mock loading state
      ctx.data({
        __typename: 'Query',
        customMatchListColumns: [],
        customMatchListColumnLimit: 5,
      })
    );
  }),
];
